import axios from 'axios'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const uploadFile: any = (file: File, tokens: any, fileType?: any) => {
  const reqBody = new FormData()
  reqBody.append('file', file)
  reqBody.append('fileType', `${fileType ?? 0}`)
  const config = {
    headers: {
      ...sitConfig(tokens).headers,
      'Content-Type': 'multipart/form-data',
      formData: true,
      parseReqBody: true,
    },
  }
  return axios.post(`${APIEndPoints.uploadFile}`, reqBody, config).then((response) => {
    return responseParser(response)
  })
}

export { uploadFile }
